import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./CookieConsent.css";
import { useTranslation } from "../../hooks/useTranslation";
import { getCookieConsent, saveCookieConsent } from "../../utils/cookieConsent";
import { initPostHog } from "../../AppContent/posthog";
import { initGA4 } from "../../AppContent/ga4";

/**
 * First-visit cookie notice: accept all, reject non-essential, or customize
 * (only "necessary" and "analytics" categories exist in this app).
 * Decision is stored in localStorage so it only ever shows once.
 *
 * @component
 */
const CookieConsent = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [analyticsChecked, setAnalyticsChecked] = useState(false);

  useEffect(() => {
    if (!getCookieConsent()) setVisible(true);
  }, []);

  const finish = (analytics) => {
    saveCookieConsent(analytics);
    if (analytics) {
      initPostHog();
      initGA4();
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="member-area cookie-consent-banner">
      <div className="cookie-consent-inner">
        {!expanded ? (
          <>
            <p className="cookie-consent-message">
              {t.cookieConsentMessage} <Link to="/privacy-policy">{t.cookieConsentLearnMore}</Link>
            </p>
            <div className="cookie-consent-actions">
              <button className="btn btn-ghost" onClick={() => setExpanded(true)}>
                {t.cookieConsentCustomize}
              </button>
              <button className="btn btn-secondary" onClick={() => finish(false)}>
                {t.cookieConsentRejectAll}
              </button>
              <button className="btn btn-primary" onClick={() => finish(true)}>
                {t.cookieConsentAcceptAll}
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="cookie-consent-row">
              <div>
                <div className="cookie-consent-row-title">{t.cookieConsentNecessaryTitle}</div>
                <div className="cookie-consent-row-body">{t.cookieConsentNecessaryBody}</div>
              </div>
              <span className="tag tag-neutral">{t.cookieConsentAlwaysOn}</span>
            </div>
            <div className="cookie-consent-row">
              <div>
                <div className="cookie-consent-row-title">{t.cookieConsentAnalyticsTitle}</div>
                <div className="cookie-consent-row-body">{t.cookieConsentAnalyticsBody}</div>
              </div>
              <label className="cookie-consent-switch">
                <input
                  type="checkbox"
                  checked={analyticsChecked}
                  onChange={(e) => setAnalyticsChecked(e.target.checked)}
                />
                <span className="cookie-consent-slider" />
              </label>
            </div>
            <div className="cookie-consent-actions">
              <button className="btn btn-ghost" onClick={() => setExpanded(false)}>
                {t.cookieConsentBack}
              </button>
              <button className="btn btn-primary" onClick={() => finish(analyticsChecked)}>
                {t.cookieConsentSavePreferences}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CookieConsent;
